module.exports = __webpack_public_path__ + "img/Contigo® Huron 2.0 Stainless Steel Travel Mug with SNAPSEAL™ Lid, 16oz.adb58eff.jpg";